import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./scss/_variable.scss";
import "./scss/common.scss"; //公共样式文件
Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css';
import API from "./commonjs/api";
import "./commonjs/axios";
import {
	Timeline,
	TimelineItem,
	Icon,
	Message,
	Input,
	Loading,
	Carousel,
	CarouselItem,
	Pagination,
    Popover,
    Tabs,
    TabPane,
} from 'element-ui';
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Popover);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
window.API = API;

router.beforeEach((to, from, next) => {
	//控制刷新后头部菜单仍保持在原来的激活状态
	next()
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')